import { OnInit } from '@angular/core';
import { FiltersBarComponent } from './filters-bar.component';
import { FiltersGroupingUI } from './filters-ui.models';
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { lastValueFrom, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { filtersFeature } from 'src/app/store/filters.era';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'filters-dialog',
    template: `
<div class="task_filter_dialog joi-dialog">
    <div mat-dialog-content>
        <filters-bar [filterGroupings]="filterGroupings" [filterPage]="filterPage" place="dialog"></filters-bar>
    </div>
    <div mat-dialog-actions>
        <button mat-button [disabled]="!( activeFilterCount | async )" (click)="clearFilter()" tabindex="-1">CLEAR FILTERS</button>
        <div style="flex:1"></div>
        <button mat-button (click)="dialogRef.close()" tabindex="-1">CANCEL</button>
        <button mat-button color="primary" (click)="applyFilter()" tabindex="-1">APPLY</button>
    </div>
</div>
    `,
    styleUrls: [`filters-dialog.scss`],
    standalone: true,
    imports: [FiltersBarComponent, MatButtonModule, AsyncPipe],
})
export class FiltersDialogComponent implements OnInit {
    filterPage: string
    filterGroupings: FiltersGroupingUI[]
    public activeFilterCount: Observable<number>
    @ViewChild(FiltersBarComponent, { static: true }) filtersBar: FiltersBarComponent

    constructor(public dialogRef: MatDialogRef<FiltersDialogComponent>, public store :Store, @Inject(MAT_DIALOG_DATA) public data: { filterPage: string, filterGroupings: FiltersGroupingUI[] }) {
        this.filterPage = data.filterPage
				this.filterGroupings = data.filterGroupings
    }

    async ngOnInit() {
        this.activeFilterCount = await lastValueFrom(this.store.select(filtersFeature.selectTempCounts))[ this.filterPage]
    }

    clearFilter() {
      this.filtersBar.clearFilter()
    }

    applyFilter() {
      this.filtersBar.applyFilter()
      this.dialogRef.close(true)
    }


}
